import { render, staticRenderFns } from "./AdminDashEventsPanel.vue?vue&type=template&id=157a2f38&scoped=true"
import script from "./AdminDashEventsPanel.vue?vue&type=script&lang=js"
export * from "./AdminDashEventsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a2f38",
  null
  
)

export default component.exports